import { GridValidRowModel } from '@mui/x-data-grid-pro'
import Pill from 'ext-ui/components/Pill/Pill'
import React from 'react'
import DataGridCell, {
  DataGridCellProps,
} from 'src/components/DataGrid/cells/DataGridCell/DataGridCell'

export type TextAndPillCellProps<Row extends GridValidRowModel> = Omit<
  DataGridCellProps<Row>,
  'subtext'
> & {
  pillText: string | React.ReactElement
  secondPillText?: string | React.ReactElement
}

const TextAndPillCell = <Row extends GridValidRowModel>(
  props: TextAndPillCellProps<Row>,
): React.ReactElement => {
  const { color, pillText, secondPillText, ...rest } = props
  return (
    <DataGridCell
      color={color}
      {...rest}
      subtext={
        <div className={'flex-row gap-1'}>
          <Pill size={'small'} color={color}>
            {pillText}
          </Pill>
          {secondPillText && (
            <Pill size={'small'} color={color}>
              {secondPillText}
            </Pill>
          )}
        </div>
      }
    />
  )
}

export default TextAndPillCell
